import React, { useState } from "react";
import { func, bool, string } from "prop-types";
import { Link } from "react-router-dom";

import { Button, Loading, Validate } from "../../common";

import { Declaration } from "../BasicInfo";
import OnboardImage from "../OnboardImage";
import * as style from "./styles.module.scss";

const constraints = {
  positionSeeking: {
    length: {
      maximum: 64,
      tooLong: "^Maximum 64 characters",
    },
  },
};

const PersonalDeclaration = (props) => {
  const { onBoarding, loading, handleSubmit, generalConsent, onChange } = props;

  return (
    <div className="row h-100">
      <OnboardImage
        imagePath="/images/personal_declaration.svg"
        title="Almost there"
        subtitle="Please read the declaration and select the checkbox to confirm."
        className={style.personalDeclaration__imageBackground}
        imageClassName={style.personalDeclaration__image}
      />

      <div
        className={`col-sm-12 col-lg-6 mt-1 mt-lg-0 ${style.personalDeclaration__declaration}`}
      >
        <div className="row">
          <div className="col-12">
            <Declaration
              hasConsented={generalConsent}
              setField={onChange}
            ></Declaration>
          </div>
        </div>

        <div
          className={`mt-lg-auto my-2 mb-lg-0 ${style.personalDeclaration__buttonContainer}`}
        >
          {onBoarding && (
            <Link
              to="/onboard/work-type"
              className="btn btn-outline-info text-dark mr-1"
            >
              Back
            </Link>
          )}
          <Validate constraints={constraints} userInput={{ generalConsent }}>
            {({ isValid }) => (
              <Button
                disabled={!generalConsent}
                classes="btn btn-primary btn-block "
                styles={{ width: 150 }}
                onClick={isValid ? handleSubmit : () => {}}
              >
                {loading ? <Loading /> : `${onBoarding ? "Next" : "Save"}`}
              </Button>
            )}
          </Validate>
        </div>
      </div>
    </div>
  );
};

PersonalDeclaration.propTypes = {
  onBoarding: bool,
  loading: bool.isRequired,
  onChange: func.isRequired,
  handleSubmit: func.isRequired,
  onboardNextRoute: string.isRequired,
  generalConsent: bool,
};

export default PersonalDeclaration;
